import * as PropTypes from "prop-types"
import styled from "styled-components"
import { useT } from "react-polyglot-hooks"
import capitalize from "lodash/capitalize"
import join from "lodash/join"
import Typography from "components/styled/Typography"
import { sendEvent } from "scripts/GoogleAnalytics"
import Item from "./Item"

const Container = styled.fieldset`
  border: 0;
  padding: 0;
  margin: 0;
  margin-bottom: 15px;
  min-width: 0;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: 50px;
  gap: 10px;
`

const Feedback = styled(Typography)`
  && {
    font-size: 1rem;
    width: 100%;
    margin: 0.25rem 0 0;
  }
`
export default function JobTypeSelector({ errors, field, handleChange, label, show, value }) {
  const t = useT()
  const options = [
    { value: "employee", label: capitalize(t("common.form.job_types.employee")) },
    { value: "freelance", label: capitalize(t("common.form.job_types.freelance")) },
    { value: "company", label: capitalize(t("common.form.job_types.company")) }
  ]

  if (!show) return null

  const handleSelectorChange = changedValue => {
    sendEvent("form job_type", {
      event_category: "car_data",
      event_label: changedValue
    })
    handleChange(field, changedValue)
  }

  const errorsValue = errors && errors[field]

  const errorsText = Array.isArray(errorsValue) ? join(errorsValue) : errorsValue

  const checkSelection = item => value === item

  return (
    <>
      {label && (
        <Typography el="span" className="mb-3" color="white">
          {label}
        </Typography>
      )}
      <div>
        <Container>
          {options.map(opt => (
            <Item key={opt.value} {...opt} onChange={handleSelectorChange} selected={checkSelection(opt.value)} />
          ))}
        </Container>
        {errorsText && (
          <Feedback color="crimson" weight="medium" style={{ textAlign: "left" }}>
            {errorsText}
          </Feedback>
        )}
      </div>
    </>
  )
}

JobTypeSelector.defaultProps = {
  show: true,
  value: "",
  label: "",
  field: "job_type"
}

JobTypeSelector.propTypes = {
  show: PropTypes.bool,
  label: PropTypes.string,
  field: PropTypes.string,
  value: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired
}
